module.exports = __webpack_public_path__ + "img/facts-wifi.b52474bb.png";